// src/pages/profesor/ProfesorAgendaPage.tsx
import ReservasCalendarPage from "../admin/agenda/ReservasCalendarPage";
import { useAuth } from "../../context/AuthContext";

export default function ProfesorAgendaPage() {
  const { user } = useAuth(); // => { id, role, … }

  return (
    <ReservasCalendarPage
      fixedFilters={{ profesorId: user!.id }} // sólo sus clases
      canCreate={false} // ⬅️  oculta botón “Nueva”
      canEdit={false} // ⬅️  oculta doble-click / context menu
    />
  );
}
